import { render } from "./bc-import-data.vue?vue&type=template&id=31124870"
import script from "./bc-import-data.vue?vue&type=script&lang=js"
export * from "./bc-import-data.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__